<template id="personal_center">
	<div>

		<div class="col-md-12 pr-0 pl-0 centre_sm_none">
			<div class="accountManage">
				<p class="account_manage_title">My focus</p>

				<div class="nano video_breviary">
					<div class="nano-content" id="home_left_list">
						<ul class="p-0 pl-4 pr-4">
							<li class="pt-4 pb-4 w-100 d-inline-block border-bottom border-top-0 border-right-0 border-left-0" v-for="homeList in homeLists" @click="Torouter(homeList.alias)">
								<div class="float-left">
									<img class="rounded-circle img-fluid" :src="homeList.photo" style="width: 70px; height: 70px;" />
								</div>
								<div class="float-left ml-4 mt-3">
									<p class="f15">{{homeList.name}}</p>
									<p class="f13 text-secondary">{{homeList.tags}}</p>
								</div>
								<div class="float-right mt-3">
									<button class="btn followedBtn f11 text-black-50">Followed</button>
								</div>
							</li>
						</ul>
                        <div v-if="homeLists.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                            <p class="text-center p-2">loading</p>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default({
		name: 'myAttention',
		data: function() {
			return {
                homeLists:[],
                current_page : 1,
                page_size : 10,
                total_pages : 0
			}
		},
		created: function() {
			var self = this;
            this.$axios.post('/api/pc/getattentionspace',{current_page:self.current_page, page_size: self.page_size}).then(data => {
                if (data.data.state) {
                    self.homeLists=data.data.data.data;
                    self.total_pages=Math.ceil(data.data.data.total/10);
                }
            })

		},
		mounted() {
            document.getElementById('home_left_list').addEventListener('scroll', this.Scrolles);
			this.load();
		},
		methods: {
            Scrolles() {
                let that = this;
                var top = document.getElementById('home_left_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_left_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_left_list').scrollHeight; // 总高度
                if ((all - 20) < (top + client)) {
                    this.current_page++;
                    if (this.current_page > this.total_pages) {
                        return;
                    }
                    this.$axios.post('/api/pc/getattentionspace', {
                        current_page: that.current_page,
                        page_size:that.page_size
                    }).then(data => {
                        if (data.data.state) {
                            var homeListes = data.data.data.data;
                            JSON.stringify(homeListes);
                            var new_homeLists = that.homeLists.concat(homeListes);
                            that.homeLists = new_homeLists;
                        }
                    })
                }
            },
            // 详情跳转
            Torouter(item) {
                this.$router.push({name:'consultdetails',params :{name:item, contentid:0}})
            },
		},
		computed: {

		}

	})
</script>
